import React from "react";
import Home from "../pages/home";
import Sms from "../pages/sms";
import LogMessages from "../pages/Dashboards/LogMessages";
import Logout from "../pages/User/logout";
import campaignsRoutes from "./campaigns";
import partnerRoutes from "./partner";
import administrationRoutes from "./administration";
import reportRoutes from "./reports";
import contactsRoutes from "./database";
import userRoutes from "./user";
import { RolesAuthRoute } from "../Context/ProtectedRoute";
import { Navigate } from "react-router-dom";
import CustomerDashboard from "../pages/Dashboards/CustomerDashboard";
import Monitor from "../pages/monitor/Monitor";
import Overview from "./overview";
const mapRole = {
  home: [1, 2, 3, 4, 5],
  sms: [1, 2, 3],
};

export const privateRoutes = [
  {
    path: "/",
    element: <Navigate to="/Home" replace />,
  },
  {
    path: "home",
    element: (
      <RolesAuthRoute roles={mapRole["home"]}>
        <Home />
      </RolesAuthRoute>
    ),
  },
  {
    path: "dashboard/customers",
    element: (
      <RolesAuthRoute roles={[1]}>
        <CustomerDashboard />
      </RolesAuthRoute>
    ),
  },
  {
    path: "sms",
    element: (
      <RolesAuthRoute roles={mapRole["sms"]}>
        <Sms />
      </RolesAuthRoute>
    ),
  },
  { path: "logout", element: <Logout /> },
  { path: "Reports/SMSLog", element: <LogMessages /> },
  ...userRoutes,
  ...campaignsRoutes,
  ...partnerRoutes,
  ...administrationRoutes,
  ...reportRoutes,
  ...contactsRoutes,
  ...Overview,
  {
    path: "dashboard/monitor",
    element: (
      <RolesAuthRoute roles={[1]}>
        <Monitor />
      </RolesAuthRoute>
    ),
  },
];
